import { PRIVATE_DINING_SECTION_ID_SUBSTRING } from '@/data'

export const getLocationListItemId = (state: string) => `id_state_${state}`


export const getPrivateDiningId = (language: string, locationSlug: string) => {
  return `${language}_${locationSlug}_${PRIVATE_DINING_SECTION_ID_SUBSTRING}`
}
